import React, { useState } from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { Icon } from 'ui';
import { AlertCircle, Check } from 'react-feather';
import Skeleton from 'react-loading-skeleton';
import request from 'utils/request_ajax';

const ConfidenceScoreFeedback = ({
  getConfidenceFeedbackRoute,
  currentUserId,
}) => {
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const handleFeedbackSubmit = async event => {
    const name = event.target.getAttribute('name');
    const confidenceFeedback = name === 'thumbs_up';
    try {
      setSubmitting(true);
      await request.postJSON(getConfidenceFeedbackRoute(event), {
        confidenceFeedback,
        userId: currentUserId,
      });
    } catch (e) {
      setError(true);
    } finally {
      setSubmitting(false);
      setFeedbackSubmitted(true);
    }
  };

  return (
    <div className="confidence-feedback border-solid border border-gray-light bdrs-small bg-gray-lightest d-f pt-24 pb-24 pl-16 pr-16 mt-24">
      {!feedbackSubmitted && !submitting && (
        <>
          <div className="f-1">
            <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
              {t('automated_analysis.confidence_score.feedback_request')}
            </Text>
          </div>
          <div className="icons d-f jc-e ai-c f-1 mr-24">
            <Icon
              name="thumbs_down"
              className="thumb p-10 is-48 mr-16 bdrs-full"
              onClick={handleFeedbackSubmit}
            />
            <Icon
              name="thumbs_up"
              className="thumb p-10 is-48 mr-16 bdrs-full"
              onClick={handleFeedbackSubmit}
            />
          </div>
        </>
      )}
      {!feedbackSubmitted && submitting && (
        <div className="w-100p">
          <Skeleton count={1} height={24} />
        </div>
      )}
      {feedbackSubmitted && !error && (
        <Text
          className="d-f ai-c"
          variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD_SUCCESS}
        >
          <Check className="pr-8" />
          {t('automated_analysis.confidence_score.feedback_success')}
        </Text>
      )}
      {feedbackSubmitted && error && (
        <>
          <AlertCircle className="c-error" width={16} />
          <Text className="c-error mr-10 ml-6" variant={TEXT_VARIANTS.BODY}>
            {t('automated_analysis.confidence_score.feedback_error')}
          </Text>
        </>
      )}
    </div>
  );
};

export default ConfidenceScoreFeedback;
